import React from 'react';
import { Banner } from './EnvironmentBanner.styles';

export const EnvironmentBanner = () => {
  if (!process.env.REACT_APP_ENVIRONMENT_NAME) {
    return null;
  }
  return <Banner>{process.env.REACT_APP_ENVIRONMENT_NAME} Environment</Banner>;
};
